import React, {  } from "react";
import * as HMS from "../../../../../common/component/Index";
import Wrapper from "../../../../../common/component/Wrapper";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Icon,
  Row,
  TimePicker,
} from "antd";
import { DatePickerComponent } from "../../../../../common/component/Index";
import {
  DATE_TIME_FORMAT, DaysOfTheWeek,
} from "../../../../../../../constants/Define";
import classNames from "classnames";
import moment from "moment";

const CheckboxGroup = Checkbox.Group;

const PackageRateConfigTime = ({
  title,
  fieldName,
  configTimeData,
  validation,
  t,
  onChange,
  isConfigProductSalesTime = false,
  disabled
}) => {
  const getDateRangeValue = (item) => {
    return item?.dateRange?.dateFrom && item?.dateRange?.dateTo
      ? [
          moment(item.dateRange.dateFrom, [DATE_TIME_FORMAT.SHORT_DATE, DATE_TIME_FORMAT.SHORT_DATE_EXPORT]),
          moment(item.dateRange.dateTo, [DATE_TIME_FORMAT.SHORT_DATE, DATE_TIME_FORMAT.SHORT_DATE_EXPORT]),
        ]
      : [];
  };

  const addStage = (onChange) => {
    const list = configTimeData?.dateRanges || [];
    onChange(`${fieldName}.dateRanges`, [...list, {}]);
  };

  const removeStage = (index, onChange) => {
    const newList = [...(configTimeData?.dateRanges || [])];
    newList.splice(index, 1);
    onChange(`${fieldName}.dateRanges`, newList);
  };

  const onSelectDateRange = (item, dates, onChange) => {
    const list = configTimeData?.dateRanges || [];
    const dateFrom = dates.value[0] ? moment(dates.value[0], DATE_TIME_FORMAT.SHORT_DATE).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT) : "";
    const dateTo = dates.value[1] ? moment(dates.value[1], DATE_TIME_FORMAT.SHORT_DATE).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT) : "";
    item.dateRange = {dateFrom: dateFrom, dateTo: dateTo};
    onChange(`${fieldName}.dateRanges`, list);
  };

  const onChangeConfig = (field, value) => {
    configTimeData[field] = value;
    onChange(`${fieldName}`, configTimeData);
  }

  const disabledDateCell = (current) => {
    return moment(current).startOf("day").isBefore(moment().startOf("day"));
  }

  return (
    <div className="bpr-section">
      <span className="bpr-headder">
        {title}
        <label className="fs15">
          <span className="colorRed mr-1">*</span>
        </label>
      </span>
      <div className="d-flex align-items-end">
        <div className="d-flex flex-column">
          {configTimeData.dateRanges?.length > 0 &&
            configTimeData.dateRanges.map((item, index) => (
              <div key={index} className="d-flex align-items-center">
                {configTimeData.dateRanges.length > 1 && (
                  <Icon
                    className="mt-2 mr-2"
                    type="close"
                    onClick={() => removeStage(index, onChange)}
                  />
                )}
                <Wrapper>
                  <HMS.FormWrapperInputComponent
                    isRequired={"hide"}
                    isValidation={true}
                    dataValidation={item?.dateRange?.dateFrom}
                    validation={
                      validation?.[fieldName]?.dateRanges?.length > index
                        ? validation[fieldName].dateRanges[index].dateFrom
                        : null
                    }
                  >
                    <DatePickerComponent
                      className={classNames(
                        "form-control applyDates w100-percent"
                      )}
                      hmsComponent={`RangePicker`}
                      format={DATE_TIME_FORMAT.SHORT_DATE}
                      disabledDate={(current) => disabledDateCell(current)}
                      style={{
                        padding: 0,
                        borderWidth: validation.schedules ? 1 : 0,
                      }}
                      onChange={(e) => onSelectDateRange(item, e, onChange)}
                      name={`applyDates`}
                      placeholder={[
                        t("item.packageRate.startDate"),
                        t("item.packageRate.endDate"),
                      ]}
                      value={getDateRangeValue(item)}
                      disabled={disabled}
                    />
                  </HMS.FormWrapperInputComponent>
                </Wrapper>
              </div>
            ))}
        </div>

        <Button
          className="ml-2"
          type="default"
          size="large"
          style={{ marginBottom: 13 }}
          onClick={() => addStage(onChange)}
          disabled={disabled}
        >
          {t("item.packageRate.addStage")}
        </Button>
      </div>

      {!isConfigProductSalesTime && (
        <div className="stage-advanced">
          <Checkbox
            checked={configTimeData?.isConfgAdvanced}
            onChange={(e) =>
              onChangeConfig("isConfgAdvanced", e.target.checked)
            }
            disabled={disabled}
          >
            {t("item.packageRate.displayAdvanced")}
          </Checkbox>

          {configTimeData?.isConfgAdvanced && (
            <>
              <div className="row mt-3">
                <div className="col-md-5">
                  <span>{t("item.packageRate.onlyApplyForTime")}</span>
                </div>

                <div className="col-md-7">
                  <TimePicker
                    className="mr-1"
                    placeholder=""
                    value={
                      configTimeData.hoursFrom
                        ? moment(configTimeData.hoursFrom, "HH:mm:ss")
                        : ""
                    }
                    onChange={(e) =>
                      onChangeConfig("hoursFrom", e?.format("HH:mm:ss"))
                    }
                    disabled={disabled}
                  />
                  {" ~ "}
                  <TimePicker
                    className="ml-1"
                    placeholder=""
                    value={
                      configTimeData.hoursTo
                        ? moment(configTimeData.hoursTo, "HH:mm:ss")
                        : ""
                    }
                    onChange={(e) =>
                      onChangeConfig("hoursTo", e?.format("HH:mm:ss"))
                    }
                    disabled={disabled}
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-5">
                  <span>{t("item.packageRate.onlyApplyForDaysOfWeek")}</span>
                </div>

                <div className="col-md-7">
                  <CheckboxGroup
                    value={configTimeData.daysOfWeek || []}
                    onChange={(e) => onChangeConfig("daysOfWeek", e)}
                    disabled={disabled}
                  >
                    <Row>
                      {DaysOfTheWeek.map((day, index) => (
                        <Col key={index} span={12}>
                          <Checkbox value={day.id}>{day.text}</Checkbox>
                        </Col>
                      ))}
                    </Row>
                  </CheckboxGroup>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PackageRateConfigTime;
